import { render, staticRenderFns } from "./FormConfirm.vue?vue&type=template&id=352f4953&scoped=true"
import script from "./FormConfirm.vue?vue&type=script&lang=js"
export * from "./FormConfirm.vue?vue&type=script&lang=js"
import style0 from "./FormConfirm.vue?vue&type=style&index=0&id=352f4953&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352f4953",
  null
  
)

export default component.exports